import { render } from "./job.vue?vue&type=template&id=27d24bfc&scoped=true&lang=pug"
import script from "./job.vue?vue&type=script&setup=true&lang=js"
export * from "./job.vue?vue&type=script&setup=true&lang=js"

import "./job.vue?vue&type=style&index=0&id=27d24bfc&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d24bfc"]])

export default __exports__